import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { wait } from '@/utils';

const { VUE_APP_BASE_URL: baseURL, VUE_APP_WS_URL: wsURL } = process.env;

export default {
  baseURL,
  wsURL,
  token: localStorage.getItem('token'),
  cleanupDelay: 0,
  init() {
    if (this.token) axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
    axios.defaults.baseURL = this.baseURL;
    bindInterceptors(axios, this);
  }
};

const bindInterceptors = (axios, instance) => {
  axios.interceptors.request.use(async req => {
    await wait(instance.cleanupDelay);
    store.commit('error/clearError');
    instance.cleanupDelay = 0;
    return req;
  });
  axios.interceptors.response.use(
    res => res,
    async ({ response: res }) => {
      store.commit('error/clearError');
      store.commit('error/setError', res, { root: true });
      if (res && res.status === 401) {
        store.commit('common/setSnackBar', true);
        await store.dispatch('auth/logout');
        return router.push('/login').catch(ex => ex);
      } else if (res && 403 === res.status) {
        return store.commit('common/setSnackBar', true);
      } else if (res && 404 === res.status) {
        return router.push({ name: 'NotFound' }).catch(e => e);
      } else {
        store.commit('common/setSnackBar', true);
      }
    }
  );
};
